/**
 * Gap detection and utilities for silence removal feature.
 */

/**
 * Information about a detected gap occurrence.
 */
export interface GapOccurrence {
    id: string;
    // Duration of the gap in seconds
    durationSec: number;
    // Start and end times (composition time)
    startSec: number;
    endSec: number;
    // Source times for audio access
    srcStartSec: number;
    srcEndSec: number;
    // Which audio source this gap belongs to
    sourceIndex: number;
    // Word before the gap
    wordBefore: {
        text: string;
        startSec: number;
        endSec: number;
    } | null;
    // Word after the gap
    wordAfter: {
        text: string;
        startSec: number;
        endSec: number;
    } | null;
    // Context: words around the gap (2 seconds before/after)
    contextBefore: string[];
    contextAfter: string[];
}

/**
 * Format duration as seconds with one decimal place.
 * e.g., 18.8 -> "18.8s"
 */
export function formatDuration(seconds: number): string {
    return `${seconds.toFixed(1)}s`;
}

/**
 * Format duration for display in context.
 * e.g., 18.8 -> "[18.8]"
 */
export function formatGapInContext(seconds: number): string {
    return `[${seconds.toFixed(1)}]`;
}

/**
 * Format timestamp as MM:SS
 */
export function formatTimestamp(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
}

